import type { Lang } from '@xr/config';
import { T } from './strings.gen.js';

export { T };
export type { Entry } from './strings.gen.js';

/**
 * Looks up a text key in the given language. Function entries get the
 * arguments (counts, names). A missing key returns the key itself, so a
 * gap shows on screen instead of crashing; tests check none are missing.
 */
export function t(lang: Lang, key: string, ...args: unknown[]): string {
  const e = T[key];
  if (!e) return key;
  const v = e[lang === 'ar' ? 1 : 0];
  return typeof v === 'function' ? v(...args) : v;
}

export const has = (key: string): boolean => key in T;
